import axios from 'axios';
import { trimStringForQuery } from 'utils/utils';

const API_URL = '/api/v1/marketing/';
const SEARCH = 'search';
const DELETE_ALL = 'all';

const createBroadcast = ({ message, phoneNumbers, marketingImage }) => {
	const formData = new FormData();
	formData.append('data', JSON.stringify({ message, phoneNumbers }))
	formData.append('marketingImage', marketingImage);

	return axios.post(
		API_URL,
		formData,
		{ headers: { 'Content-Type': 'multipart/form-data' } },
	);
};

const searchEventLogs = ({ filterQuery, dateRangeFilter, pageIndex, pageSize, sortBy }) => {
	const body =  {
		page: pageIndex,
		count: pageSize,
		sortBy: sortBy?.length ? sortBy : [{ id: 'sentAt', desc: true }],
		descending: true,
		include: [
			'sentAt',
			'type',
			'customerPhoneNumber',
			'sentResult',
			'isSent',
		],
		filters: [
			{
				type: 'string',
				name: 'type',
				value: 'MARKETING_NOTIFICATION',
				exactMatch: true,
				negative: false,
			},
			{
				type: 'string',
				name: 'customerPhoneNumber',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
				negative: false,
			}
		],
	};

	(dateRangeFilter?.from || dateRangeFilter?.to) && body.filters.push({
		type: 'date',
		name: dateRangeFilter?.name,
		from: dateRangeFilter?.from?.toISOString(),
		to: dateRangeFilter?.to?.toISOString(),
	});

	return axios.post(`${API_URL}${SEARCH}`, body);
};

const deleteEventLogs = (idsToDelete) => {
	return axios.delete(`${API_URL}`, {
		data: { idsToDelete }
	});
};

const deleteAllEventLogs = () => axios.delete(`${API_URL}${DELETE_ALL}`);

export {
	createBroadcast,
	searchEventLogs,
	deleteEventLogs,
	deleteAllEventLogs,
};
